import { render } from "./PopupListView.vue?vue&type=template&id=373bbce1&scoped=true"
import script from "./PopupListView.vue?vue&type=script&lang=ts"
export * from "./PopupListView.vue?vue&type=script&lang=ts"

import "./PopupListView.vue?vue&type=style&index=0&id=373bbce1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-373bbce1"

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd,QToggle,QBtn,QSpace});
